export default function PHP_Remove_Array_Items() {
  return (
    <div>
      <h1>PHP_Remove_Array_Items</h1>
    </div>
  );
}
